import type { ArticleTeaser } from '@/components/ArticleTeaser';

import { ArticleInTextTeaser } from './ArticleInTextTeaser';

export const StandaloneArticleInTextTeaser: typeof ArticleTeaser = (props) => <ArticleInTextTeaser {...props} />;
